import axios from "@/utils/axiosRequest"
// 登录
export const Login = (user)=>{
    return axios.request({
        url:"/tianwei/adduser",
        method:"POST",
        data:user
    })
}
// 注册
export const Register = (com)=>{
    return axios.request({
        url:"/tianwei/upduser",
        method:"POST",
        data:com
    })
}
// 修改个人信息
export const editRegister = (com)=>{
    return axios.request({
        url:"/tianwei/upduserstatus",
        method:"POST",
        data:com
    })
}
// 修改密码
export const editPassword = (com)=>{
    return axios.request({
        url:"/note/upnote",
        method:"POST",
        data:com
    })
}
// 修改手机号时获取验证码后下一步
export const nextCode = (com)=>{
    return axios.request({
        url:"/tianwei/nextstep",
        method:"POST",
        data:com
    })
}
// 登录和注册获取验证码
export const getReCode = (com)=>{
    return axios.request({
        url:"/tianwei/getcode",
        method:"POST",
        data:com
    })
}
// 获取省市
export const getSheng = (com)=>{
    return axios.request({
        url:"/tianwei/selsheng",
        method:"POST",
        data:com
    })
}
// 上传项目
export const addProgram = (com,process)=>{
    return axios.request({
        url:"/tianwei/twdonateitem",
        onUploadProgress: process,
        method:"POST",
        data:com
    })
}
// 获取项目列表
export const getProgramList = (com)=>{
    return axios.request({
        url:"/tianwei/seldonateitem",
        method:"POST",
        data:com
    })
}
// 项目状态修改
export const changeStatus = (com)=>{
    return axios.request({
        url:"/tianwei/updreject",
        method:"POST",
        data:com
    })
}
// 项目删除
export const delProgram = (com)=>{
    return axios.request({
        url:"/tianwei/deldonateitem",
        method:"POST",
        data:com
    })
}
// 添加捐赠人员信息
export const addJzUser = (com)=>{
    return axios.request({
        url:"/tianwei/setdonor",
        method:"POST",
        data:com
    })
}
// 添加受助人员信息
export const addSzUser = (com)=>{
    return axios.request({
        url:"/tianwei/recipient",
        method:"POST",
        data:com
    })
}
// 获取捐赠人员列表
export const getJzUserList = (com)=>{
    return axios.request({
        url:"/tianwei/seldonor",
        method:"POST",
        data:com
    })
}
// 获取受助人员列表
export const getSzUserList = (com)=>{
    return axios.request({
        url:"/tianwei/selrecipient",
        method:"POST",
        data:com
    })
}
// 获取总体的金额情况
export const getAllList = ()=>{
    return axios.request({
        url:"/tianwei/selpandect",
        method:"POST",
    })
}


